import { MuiTelInput, MuiTelInputProps } from 'mui-tel-input';

type CommonNumberInputProps = MuiTelInputProps;

export const CommonPhoneInput = (props: CommonNumberInputProps) => {
  return <MuiTelInput defaultCountry="US" {...props} />;
};
